jQuery(document).ready(function ($) {
    'use strict';

    $('.gfield input').change(function () {
        if ( $(this).val() ) {
            $(this).closest('.gfield').addClass('has-value');
        } else {
            $(this).closest('.gfield').removeClass('has-value');
        }
    });

    $('.gform_wrapper form').each(function () {
        $(this).removeAttr('novalidate');
    });

    let formelems = document.querySelectorAll('.gfield_contains_required input');
    formelems.forEach((formelem) => {
        formelem.required = true;
    });

    $('.captcha input').change(function () {
        if ( $(this).val() ) {
            $('.gform_button').prop('disabled', true);
        } else {
            $('.gform_button').prop('disabled', false);
        }
    });

});
//# sourceMappingURL=forms.js.map
